import '@formatjs/intl-durationformat/polyfill.js';
import { getConfig } from '@/constants/config';

export const formatElapsedDuration = (seconds: number): string =>
  new Intl.DurationFormat(getConfig().locale, { style: 'short', secondsDisplay: 'always' }).format({
    minutes: Math.floor(seconds / 60),
    seconds: seconds % 60,
  });
